
import axios from 'axios'
import Cookies from 'js-cookie'
import * as types from '../mutation-types'

// state
export const state = {
  course: null,
  courses: null,
  terms: null,
  department: null,
  subject: null,
  term: null,
  status: null,
  offline: null
}

// getters
export const getters = {
  course: state => state.courses,
  courses: state => state.courses,
  terms: state => state.terms,
  department: state => state.department,
  subject: state => state.subject,
  term: state => state.term,
  status: state => state.status,
  offline: state => state.offline
}

// mutations
export const mutations = {
  [types.FETCH_COURSE_SUCCESS] (state, { course }) {
    state.course = course
  },

  [types.FETCH_COURSE_FAILURE] (state) {
    state.course = null
    state.offline = true
  },

  [types.FETCH_COURSES_SUCCESS] (state, { courses }) {
    state.courses = courses
  },

  [types.FETCH_COURSES_FAILURE] (state) {
    state.courses = []
    // state.offline = true
  },

  [types.FETCH_TERMS_SUCCESS] (state, { terms }) {
    state.terms = terms
  },

  [types.FETCH_TERMS_FAILURE] (state) {
    state.terms = null
    state.offline = true
  },

  [types.UPDATE_TERM] (state, { term }) {
    state.term = term
  },

  [types.UPDATE_COURSES] (state, { courses }) {
    state.courses = courses
  },

  [types.UPDATE_DEPARTMENT] (state, { department }) {
    state.department = department.toUpperCase()
  },

  [types.UPDATE_SUBJECT] (state, { subject }) {
    state.subject = subject.toUpperCase()
  },

  [types.UPDATE_STATUS] (state, { status }) {
    if(status === 'open') {
      state.status = 'Open'
    } else if(status === 'closed') {
      state.status = 'Closed'
    } else if(status === 'waitlist') {
      state.status = 'Closed w/ Waitlist'
    } else {
      state.status = status
    }
  }
}

// actions
export const actions = {
  updateTerm ({ commit }, payload) {
    commit(types.UPDATE_TERM, payload)
  },

  updateCourses ({ commit }, payload) {
    commit(types.UPDATE_COURSES, payload)
  },

  updateDepartment ({ commit }, payload) {
    commit(types.UPDATE_DEPARTMENT, payload)
  },

  updateSubject ({ commit }, payload) {
    commit(types.UPDATE_SUBJECT, payload)
  },

  updateStatus ({ commit }, payload) {
    commit(types.UPDATE_STATUS, payload)
  },

  async fetchCourse ({ commit }, term, course) {
    // try {
    //   let xml = '<?xml version="1.0"?><detail><strm>'+term+'</strm><class_nbr>'+course+'</class_nbr></detail>'
    //   let config = {headers: {'Content-Type': 'text/xml;charset=UTF-8'}}
    //   const { data } = await axios.post('https://my.ucsc.edu/PSIGW/HttpListeningConnector/', xml, config)
    //   commit(types.FETCH_COURSE_SUCCESS, { course: data })
    // } catch (e) {
    //   commit(types.FETCH_COURSE_FAILURE)
    // }

    try {
      // const { data } = await axios.get('/api/course/'+term+'/'+course)
      // const { data } = await axios.get('https://webapps-dev.ucsc.edu/wcsi/api/course/'+term+'/'+course)
      // const { data } = await axios.get('https://my.dev.ais.aws.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSDEV/SCX_CLASS_DETAIL.v1/'+term+'/'+course)
      const { data } = await axios.get('https://my.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSPRD/SCX_CLASS_DETAIL.v1/'+term+'/'+course)
      commit(types.FETCH_COURSES_SUCCESS, { courses: data.results.classes.class })
    } catch (e) {
      commit(types.FETCH_COURSES_FAILURE)
    }
  },

  async fetchCourses ({ commit }) { 
    try {
      // const { data } = await axios.get('/api/courses')
      // const { data } = await axios.get('https://webapps-dev.ucsc.edu/wcsi/api/courses')
      // const { data } = await axios.get('https://my.dev.ais.aws.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSDEV/SCX_CLASS_LIST.v1/'+state.term+'?subject='+state.department)
      var qs = ''
      if(state.subject) {
        qs = 'subject='+state.subject
        if(state.department) {
          qs += '&'
        }
      }
      if(state.department) {
        qs = 'dept='+state.department
      }
      const { data } = await axios.get('https://my.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSPRD/SCX_CLASS_LIST.v1/'+state.term+'?'+qs) 
      commit(types.FETCH_COURSES_SUCCESS, { courses: data.classes })
    } catch (e) {
      commit(types.FETCH_COURSES_FAILURE)
    }
  },

  async fetchTerms ({ commit }) {
    try {
      // const { data } = await axios.get('/api/terms')
      // const { data } = await axios.get('https://webapps-dev.ucsc.edu/wcsi/api/terms')
      // const { data } = await axios.get('https://my.dev.ais.aws.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSDEV/SCX_CLASS_TERMS.v1')
      const { data } = await axios.get('https://my.ucsc.edu/PSIGW/RESTListeningConnector/PSFT_CSPRD/SCX_CLASS_TERMS.v1')
      // console.log(data.terms)
      commit(types.FETCH_TERMS_SUCCESS, { terms: data.terms })

      // also update active term to store.term
      commit(types.UPDATE_TERM, { term: findActiveTerm(data.terms) })
    } catch (e) {
      commit(types.FETCH_TERMS_FAILURE)
    }
  }
}

function findActiveTerm (terms) {
  const result = {}
  
  Object.keys(terms).forEach(key => {
    // const term = terms[key]
    // console.log(terms[key].default)
    if (terms[key].default === "Y") {
      // console.log('hi')
      result[0] = terms[key]
      
    }
  })
  // console.log(result) 
  // console.log(result[0].code)
  return result[0].code
}


// WEBPACK FOOTER //
// /resources/js/store/modules/courses.js